import Api from '@/api';

const getLoggedInPerson = () => new Promise((resolve, reject) => {
  Api.personService.getMyPerson()
    .then(response => resolve(response.data))
    .catch(error => reject(error));
});

const passwordReset = (context, data) => new Promise((resolve, reject) => {
  const { email, recaptchaToken } = data;
  Api.personService.resetPassword(email, recaptchaToken)
    .then(response => resolve(response.data))
    .catch(error => reject(error.data));
});

const updatePassword = (context, payload) => new Promise((resolve, reject) => {
  const { personId, password, token } = payload;
  Api.personService.postPasswordUpdate(personId, password, token)
    .then(response => resolve(response.data))
    .catch(error => reject(error.data));
});

const checkByEmail = (context, payload) => new Promise((resolve, reject) => {
  const { email } = payload;
  Api.personService.checkEmail(email)
    .then(response => resolve(response.data))
    .catch(error => reject(error.data));
});

const checkByEmailAccountType = (context, payload) => new Promise((resolve, reject) => {
  const { email } = payload;
  const { type } = payload;
  Api.personService.checkEmail(email, type)
    .then(response => resolve(response.data))
    .catch(error => reject(error.data));
});

const createUserAccount = (context, payload) => new Promise((resolve, reject) => {
  const { user } = payload;
  Api.personService.createAccount(user)
    .then(response => resolve(response.data))
    .catch(error => reject(error.data));
});

export default {
  getLoggedInPerson,
  passwordReset,
  updatePassword,
  checkByEmail,
  createUserAccount,
  checkByEmailAccountType,
};
